import React from "react";
import { useSelector } from "react-redux";
import { shortenString } from "../../../../Constant/helper";
import DynamicTable from "../../CommonComponents/Table/DynamicTable";
import { Box } from "@mui/material";

function ImportAgent({ obj }) {
  let { onChange, mainState, loading } = obj;
  const reducer: any = useSelector((state) => state);
  const {
    AgentReducer: { allAgents },
  } = reducer;

  return (
    <Box
      sx={{
        m: 1,
        height: "440px",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
      }}
    >
      <Box>
        <DynamicTable
          columns={[
            {
              label: "#",
              render: (row) => {
                return (
                  <>
                    <input
                      onChange={() => onChange(row._id)}
                      type="checkbox"
                      checked={mainState?.selectedAgent?.includes(row?._id)}
                    />
                  </>
                );
              },
            },
            {
              label: "AGENT NAME",
              render: (row) => {
                return shortenString(row?.agentName, 15);
              },
            },
            {
              label: "ORGANISATION NAME",
              render: (row) => {
                return shortenString(row?.organisationName, 15);
              },
            },
            {
              label: "PROJECT NAME",
              render: (row) => {
                return shortenString(row?.projectName, 15);
              },
            },
          ]}
          data={allAgents}
          showTotalRows={true}
          loading={loading}
          totalPages={0}
          currentPage={0}
          handlePageChange={() => ""}
          handlePrevious={() => ""}
          handleNext={() => ""}
          noDataAvailableMessage={"No Agents Available"}
          rowCount={allAgents?.length}
          pagination={false}
          style={{
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          }}
        />
      </Box>
    </Box>
  );
}

export default ImportAgent;
